import React from 'react';
import { Container } from 'react-bootstrap';
import './TrajectoryStats.css';
import { useLanguage } from '../../context/LanguageContext';

// Import SVG icons
import experienceIcon from '../../images/icons/NewIcons/TrajectoryStats/1-años-experiencia.svg';
import projectsIcon from '../../images/icons/NewIcons/TrajectoryStats/2-suitcase.svg';
import industriesIcon from '../../images/icons/NewIcons/TrajectoryStats/3-building.svg';
import solutionsIcon from '../../images/icons/NewIcons/TrajectoryStats/4-verified.svg';

const TrajectoryStats: React.FC = () => {
  const { t } = useLanguage();

  const stats = [
    {
      value: '+15',
      label: t('about.trayectory.years'),
      icon: experienceIcon,
    },
    {
      value: '+50',
      label: t('about.trayectory.projects'),
      icon: projectsIcon,
    },
    {
      value: '+10',
      label: t('about.trayectory.industries'),
      icon: industriesIcon,
    },
    {
      value: '100%',
      label: t('about.trayectory.solutions'),
      icon: solutionsIcon,
    },
  ];

  return (
    <section className="trajectory-stats-section" id="about">
      <Container>
        <div className="stats-container">
          {stats.map((stat, index) => {
            return (
              <div key={index} className="stat-item">
                <div className="stat-card">
                  <div className="stat-icon-wrapper">
                    <img src={stat.icon} alt={stat.label} className="stat-icon" />
                  </div>
                  <div className="stat-content">
                    <h3 className="stat-value">{stat.value}</h3>
                    <p className="stat-label">{stat.label}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default TrajectoryStats;
